import {
  ADD_AUTOPLAY_VIDEO,
  SET_AUTOPLAY_VIDEO_IN_VIEW
} from './entity-actions';

export function feedEntityInit({
  entity,
  parentEntityId,
  entityId,
  trackAnalytics,
  isAutoplayEnabled,
  autoPlayVideos
}) {
  return {
    entity,
    parentEntityId,
    entityId,
    trackAnalytics,
    isAutoplayEnabled,
    autoPlayVideos
  };
}

export function feedEntityReducer(state, action) {
  switch (action.type) {
    case ADD_AUTOPLAY_VIDEO: {
      const { autoPlayVideo } = action.payload;
      return {
        ...state,
        autoPlayVideos: { ...state.autoPlayVideos, ...autoPlayVideo }
      };
    }
    case SET_AUTOPLAY_VIDEO_IN_VIEW: {
      const { autoPlayVideoInView } = action.payload;
      return { ...state, autoPlayVideoInView };
    }

    default:
      throw new Error(`${action.type} - not recognised`);
  }
}

export default { feedEntityInit, feedEntityReducer };
